import React from "react";
import { styled } from "@mui/material/styles";
import {
  CardActions as MuiCardActions,
  CardActionsProps as MuiCardActionsProps,
  Divider,
} from "@mui/material";

export interface CardActionsProps extends MuiCardActionsProps {
  divider?: boolean;
}

const StyledCardActions = styled(MuiCardActions)<CardActionsProps>(() => ({
  display: "flex",
  justifyContent: "end",
  width: "100%",
}));

const CardActions = React.forwardRef<HTMLDivElement, CardActionsProps>(
  ({ divider = true, ...props }, ref) => {
    return (
      <>
        {divider && <Divider />}
        <StyledCardActions ref={ref} {...props} />
      </>
    );
  }
);

CardActions.displayName = "CardActions";

export default CardActions;
